import React, { useEffect, useState } from 'react';
import './noticeDetails.css';
import { useNavigate, useParams } from 'react-router';
import slugify from 'slugify';
import DOMPurify from 'dompurify';

const NoticeDetails = () => {
  const { title } = useParams();
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;

  const [notice, setNotice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [notices, setNotices] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const fetchNotice = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${apiUrl}/api/notice`);
        if (response.ok) {
          let data = await response.json();
          data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          setNotices(data);

          const foundNotice = data.find(item =>
            slugify(item.title, { lower: true, remove: /[*+~.()'"!:@]/g }) === title
          );

          if (foundNotice) {
            const imgSrc = foundNotice.img?.startsWith("http")
              ? foundNotice.img
              : `${imageBaseUrl}/${foundNotice.img}`;
            setNotice({ ...foundNotice, img: imgSrc });
          } else {
            setError("Duyuru bulunamadı!");
          }
        } else {
          setError("Duyuru yüklenirken hata oluştu!");
        }
      } catch (error) {
        console.error("Hata:", error);
        setError("Bağlantı hatası oluştu!");
      } finally {
        setLoading(false);
      }
    };
    fetchNotice();
  }, [title, apiUrl, imageBaseUrl]);

  const formatDate = (dateString) => {
    if (!dateString) return "Tarih Yok";
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  };

  const handleImageClick = (src) => {
    setSelectedImage(src);
  };

  const handleCloseImage = () => {
    setSelectedImage(null);
  };

  const selectedNoticeIndex = notices.findIndex(item =>
    slugify(item.title, { lower: true, remove: /[*+~.()'"!:@]/g }) === title
  );

  let displayedNotices;
  if (selectedNoticeIndex === -1 || notices.length <= 6) {
    displayedNotices = notices;
  } else {
    const start = Math.max(0, selectedNoticeIndex - 3);
    const end = Math.min(notices.length, selectedNoticeIndex + 4);
    displayedNotices = notices.slice(start, end);
  }

  if (loading) return <p style={{ textAlign: 'center', fontSize: '18px' }}>Yükleniyor...</p>;
  if (error) return <p style={{ textAlign: 'center', fontSize: '18px', color: 'red' }}>{error}</p>;

  return (
    <>
      <div className="notic-details-page">
        <div className="notice-details-bg"></div>

        <div className="notice-details-wrap">
          <div className="side-notice">
            <div className="side-notice-elements">
              <div className="side-notice-title">
                <h4>Duyurular</h4>
              </div>
              {displayedNotices.map((item, index) => {
                const isSelected = slugify(item.title, { lower: true, remove: /[*+~.()'"!:@]/g }) === title;
                return (
                  <div
                    onClick={() => navigate(`/duyurular/${slugify(item.title, { lower: true, remove: /[*+~.()'"!:@]/g })}`)}
                    key={index}
                    className="notice-border"
                  >
                    <div className={`side-notice-elements-info ${isSelected ? 'selected-notice' : ''}`}>
                      <div className="side-notice-elements-info-date">
                        <p>{formatDate(item.createdAt)}</p>
                      </div>
                      <div className="side-notice-elements-info-title">
                        <p>{item.title}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="more-notice">
              <p onClick={() => navigate("/duyurular")}>Tümü</p>
            </div>
          </div>

          <div className="notice-details">
            <div className="notice-details-title">
              <h2>{notice.title}</h2>
            </div>
            <div className="notice-details-content">
              <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notice.content) }} />
            </div>
            {notice.img ? (
            <div className="notice-image" onClick={() => handleImageClick(notice.img)}>
              <img
                  style={{
                    maxWidth: "30%",
                    height: "auto",
                    aspectRatio: "3/2",
                    objectFit: "cover",
                    cursor: "pointer",
                    marginTop: "50px",
                    borderRadius: "5px"
                  }}
                  src={notice.img}
                  alt="Duyuru Resmi"
                  className="small-image"
                />
            </div>
          ) : null}
          </div>
        </div>
      </div>

      {selectedImage && (
        <div className="image-overlay" onClick={handleCloseImage}>
          <div className="image-popup">
            <span className="close-btn" onClick={handleCloseImage}>&times;</span>
            <img src={selectedImage} alt="Büyütülmüş Görsel" />
          </div>
        </div>
      )}
    </>
  );
};

export default NoticeDetails;
